/* Copyright (c) 2017 Backpack Health LLC */

import React, { Component } from 'react';
import classnames from 'classnames';

import CircleWithBorder from './CircleWithBorder';
import { colorClassNames } from '../styles/Colors';
import { Icons } from '../../bphComponents/bundle';

interface Props {
  isSelected?: boolean;
  isDisabled?: boolean;
  isHighlighted?: boolean;
  hideBorder?: boolean;
  className?: string;
  style?: any;
  data: any;
  onClick(d): void;
  children?: any;
  isHighlightedClassName?: string;
  fillClassName: string;
  isLeftBasedCircle?: boolean;
}

class SelectableRow extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { isDisabled, data } = this.props;
    if (isDisabled) return;

    this.props.onClick(data);
  }

  render() {
    const { isSelected, hideBorder, isHighlighted, children, isDisabled, className, style, isLeftBasedCircle = false } = this.props;
    const mainStyles = classnames('cmp-selectablerow is-clickable', className, {
      [this.props.isHighlightedClassName]: isHighlighted,
      'is-selected': isSelected,
      'hide-border': hideBorder,
    });

    return (
      <div className={mainStyles} style={style} onClick={this.handleClick}>
        {!isLeftBasedCircle && <div style={{ width: '100%' }}>
          {children}
        </div>}

        <div style={{ position: 'relative' }}>
          <div
            className={isSelected
              ? (isDisabled ? colorClassNames.fill('middle-gray') : this.props.fillClassName)
              : `${colorClassNames.stroke('inactive')} ${colorClassNames.fill('transparent')}`
            }
          >
            <CircleWithBorder size={32}/>
          </div>

          <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
            <Icons.IconCheckmark.Small color={isSelected ? 'white' : 'transparent'} />
          </div>
        </div>

        {isLeftBasedCircle && <div style={{ width: '100%' }}>
          {children}
        </div>}
      </div>
    );
  }
}

export const SelectableRowWithProfileTheme = (props) => {
  return <SelectableRow fillClassName="fill-color-profile" isHighlightedClassName="profile-background-color-10" {...props} className={classnames('util-application-frame-forcards-padding', props.className)} />;
};

export const SelectableRowWithGroupTheme = (props) => {
  return <SelectableRow fillClassName="theme-group base fill" isHighlightedClassName="theme-group base trans-10 background" {...props} className={classnames('util-application-frame-forcards-padding', props.className)} />;
};

export const SelectableCardRowWithProfileTheme = (props) => {
  return <SelectableRow fillClassName="fill-color-profile-highlight" isHighlightedClassName="profile-background-color-10" {...props} className={classnames('util-application-card-padding', props.className)} />;
};

export const SelectableCardRowWithGroupTheme = (props) => {
  return <SelectableRow fillClassName="theme-group base fill" isHighlightedClassName="theme-group base trans-10 background" {...props} className={classnames('util-application-card-padding', props.className)} />;
};

export const SelectableCardRowWithGroupSurveyTheme = (props) => {
  return <SelectableRow fillClassName="theme-group highlight fill" isHighlightedClassName="theme-group base trans-10 background" {...props} className={classnames('util-application-frame-forcards-padding', props.className)} />;
};

export default SelectableRow;
